<header class="header-area p-relative">
  <div class="navbar-area navbar-style-four" id="header">
    <div class="ednuv-responsive-nav">
      <div class="container">
        <div class="ednuv-responsive-menu">
          <div class="logo">
            <a routerLink="/">
              <img alt="logo" src="assets/img/black-logo.png">
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="ednuv-nav">
      <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
          <a class="navbar-brand" routerLink="/">
            <img alt="logo" src="assets/img/black-logo.png">
          </a>

          <div class="collapse navbar-collapse mean-menu">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a [routerLinkActiveOptions]="{exact: true}" class="nav-link" routerLink="/"
                   routerLinkActive="active"> Главная </a>
              </li>
              <li class="nav-item"><a class="nav-link" routerLink="/about-us">О нас</a></li>
              <li class="nav-item"><a class="nav-link" routerLink="/courses">Курсы</a></li>
              <li class="nav-item"><a class="nav-link" routerLink="/subject-list">Тесты</a></li>
              <li class="nav-item"><a class="nav-link" routerLink="/contacts">Контакты</a></li>
              <li class="nav-item for-mobile-only">
                <a *ngIf="isStudentLoggedIn" class="nav-link" routerLink="/profile"> <i class='bx bx-user'></i>
                  Личный кабинет</a>
              </li>
              <li class="nav-item for-mobile-only">
                <a (click)="logOut()" *ngIf="isStudentLoggedIn" class="nav-link"><i class='bx bx-log-out'></i>Выйти</a>
              </li>
              <li class="nav-item for-mobile-only">
                <a *ngIf="!isStudentLoggedIn" class="nav-link" routerLink="/student/login"><i class='bx bxs-user'></i>
                  Войти</a>
              </li>
              <li class="nav-item for-mobile-only">
                <a *ngIf="!isStudentLoggedIn" class="nav-link" routerLink="/student/register">
                  <i class='bx bxs-user'></i>Зарегистрироваться</a>
              </li>
            </ul>

            <!--            Let's implement i18n at the end of development-->
            <!--            <div class="others-option">-->
            <!--              <div class="dropdown language-switcher d-inline-block">-->
            <!--                <button aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-toggle="dropdown"-->
            <!--                        type="button">-->
            <!--                  <img alt="image" class="shadow" src={{language?.flag}}>-->
            <!--                  <span>{{language?.lan}}<i class='bx bx-chevron-down'></i></span>-->
            <!--                </button>-->

            <!--                <div class="dropdown-menu">-->
            <!--                  <a (click)="switchLang('rus','assets/img/russia-flag.jpg')"-->
            <!--                     class="dropdown-item d-flex align-items-center">-->
            <!--                    <img alt="flag" class="shadow-sm" src="assets/img/russia-flag.jpg">-->
            <!--                    <span>Рус</span>-->
            <!--                  </a>-->
            <!--                  <a (click)="switchLang('kyr','assets/img/kyrgyzstan-flag.jpg')"-->
            <!--                     class="dropdown-item d-flex align-items-center">-->
            <!--                    <img alt="flag" class="shadow-sm" src="assets/img/kyrgyzstan-flag.jpg">-->
            <!--                    <span>Кыр</span>-->
            <!--                  </a>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->

            <div *ngIf="isStudentLoggedIn" class="others-option">
              <div class="d-inline-block">
                <a class="last" routerLink="/profile"><i class='bx bx-user'></i>
                  Личный кабинет &nbsp;&nbsp;
                </a>
              </div>
              <div class="d-inline-block">
                <a (click)="logOut()" class="last"><i class='bx bx-log-out'></i> Выйти </a>
              </div>
            </div>
            <div *ngIf="!isStudentLoggedIn" class="others-option">
              <div class="d-inline-block">
                <a class="last" routerLink="/student/login"><i class='bx bxs-user'></i>Войти &nbsp;&nbsp;</a>
              </div>
              <div class="d-inline-block">
                <a class="last" routerLink="/student/register"><i class='bx bxs-user'></i>Зарегистрироваться</a>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</header>

<!--<div class="search-overlay">-->
<!--  <div class="d-table">-->
<!--    <div class="d-table-cell">-->
<!--      <div class="search-overlay-layer"></div>-->
<!--      <div class="search-overlay-layer"></div>-->
<!--      <div class="search-overlay-layer"></div>-->

<!--      <div class="search-overlay-close">-->
<!--        <span class="search-overlay-close-line"></span>-->
<!--        <span class="search-overlay-close-line"></span>-->
<!--      </div>-->

<!--      <div class="search-overlay-form">-->
<!--        <form>-->
<!--          <input class="input-search" placeholder="Search here..." type="text">-->
<!--          <button type="submit"><i class='bx bx-search-alt'></i></button>-->
<!--        </form>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
